import {BaseDomainDataSource} from "../../../../../infrastructure/models/base-domain-data-source";
import type {BettingZoneSiteSettingsResponseApiModel} from "./betting-zone.site-settings.response-api.model";
import {MainMenuDomainModel} from "../../main-menu/main-menu.domain-model";

export class BettingZoneSiteSettingsDataSource extends BaseDomainDataSource {
  mainMenu: Array<MainMenuDomainModel>;
  terms: Map<String, String>;
  sitePages: Object;
  publisherId: Number;

  constructor(model: BettingZoneSiteSettingsResponseApiModel) {
    super(model);

    this.mainMenu = model.main_menu?.map(item => new MainMenuDomainModel(item));
    this.sitePages = model.site_pages;
    this.terms = new Map();
    this.publisherId = model.publisher_id;

    if (model.terms) {
      Object.entries(model.terms).forEach(([key, value]) => {
        this.terms.set(key, value);
      });
    }
  }
}